// extracted by mini-css-extract-plugin
export var sidebar = "Sidebar-module--sidebar--1bfa1";
export var sidebar__inner = "Sidebar-module--sidebar__inner--e8eff";
export var sidebar__open__inner = "Sidebar-module--sidebar__open__inner--a6099";